import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Utils } from '../../../common/services/utils.service';

@Component({
  selector: 'app-fence-modal',
  templateUrl: './fence-modal.component.html',
  styleUrls: ['./fence-modal.component.css']
})
export class FenceModalComponent implements OnInit {

  fenceDetails: object[];
  buttonValidations = {
    canSaveAndEdit: false,
    canDel: false,
    canCancel: false
  };
  coordinates: object[];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private authService: AuthService,
    private httpService: HttpRequestService,
    private utils: Utils) { }

  onSaveFence() {
    const coordinates = [];
    this.config.data.coordinates.map((elem) => {
      coordinates.push((typeof (elem.lng) === 'function' ? elem.lng() : elem.lng) + ',' + (typeof (elem.lat) === 'function' ? elem.lat() : elem.lat));
    });
    // const extendeData = {
    //   'workFlowName': 'cudFence',
    //   'workFlowParams': {
    //     'methodName': 'cudFence',
    //     'fences': [{
    //       'name': this.fenceName,
    //       'description': this.description,
    //       'coordinates': coordinates.join(','),
    //       'isNew': true,
    //       'createdDate': (new Date()).getTime()
    //     }],
    //     'strToken': this.authService.getAuthorizationToken(),
    //     'strUserId': this.authService.getLoggedUserName(),
    // 'fenceCreatedBy': this.authService.getLoggedUserName()
    //   }
    // }
    const extendeData = {
      'workFlowName': 'cudFence',
      'processType': 'Screen',
      'workFlowParams': {
        'methodName': 'cudFence',
        'fences': [
          {
            'geo_cd': this.config.data.polygon.id ? this.config.data.polygon.id : '',
            'name': this.fenceDetails['geo_nm'],
            'description': this.fenceDetails['description'],
            'coordinates': coordinates.join(','),
            'isNew': !(!!this.config.data.polygon.id),
            'createdDate': (new Date()).getTime()
          }
        ],
        'strToken': '-1469644598',
        'strUserId': 'testuser',
        'strFenceUserId': this.authService.getLoggedUserName()
      }
    };
    // this.httpService.configRequestDataWithHeaders(requestData, 'post', '', false, this.httpService.ivmsBaseUrl)
    this.httpService.getFenceDetails(extendeData)
      .subscribe((response: any) => {
        const hdrcache = response.hdrcache[0];
        this.fenceDetails = hdrcache ? hdrcache : this.fenceDetails;
        this.fenceDetails['isSelected'] = true;
        const params = {
          eventName: 'save',
          polygon: this.config.data.polygon,
          data: this.fenceDetails,
          coordinates: this.coordinates
        };
        this.closeFence(params);
      });
  }

  onCancelFence() {
    this.ref.close({
      eventName: 'cancel',
      polygon: this.config.data.polygon
    });
  }

  onCloseFence() {
    this.ref.close({
      eventName: 'close',
      polygon: this.config.data.polygon,
      data: this.fenceDetails,
      coordinates: this.coordinates
    });
  }

  closeFence(param) {
    this.ref.close(param);
  }

  onEditFence() {
    this.fenceDetails['modified_dt'] = (new Date()).getTime();
    this.closeFence({
      eventName: 'edit',
      data: this.fenceDetails,
      polygon: this.config.data.polygon,
      coordinates: this.coordinates
    });
  }

  onDeleteFence() {
    const extendeData = {
      'workFlowName': 'delFence',
      'workFlowParams': {
        'methodName': 'delFence',
        'fenceId': this.config.data.polygon.id,
        'strToken': '-1469644598',
        'strUserId': 'testuser',
        'strFenceUserId': this.authService.getLoggedUserName(),
        'createdDate': (new Date()).getTime()
      }
    };
    this.httpService.getFenceDetails(extendeData)
      .subscribe((response: any) => {
        this.closeFence({
          eventName: 'delete',
          polygon: this.config.data.polygon
        });
      });
  }

  validateMasterOrTransac() {
    this.buttonValidations.canSaveAndEdit = !this.config.data.isFromTransaction;
    this.buttonValidations.canCancel = this.config.data.isFromTransaction ? !this.config.data.isFromTransaction : this.config.data.isAdd;
    this.buttonValidations.canDel = this.config.data.isFromTransaction ? !this.config.data.isFromTransaction : !this.config.data.isAdd;
  }

  ngOnInit() {
    this.fenceDetails = this.config.data.info ? this.config.data.info : { geo_nm: '', description: '', geo_gis_data: '' };
    this.config.data.gmapCb.addStyleControl(document.getElementsByClassName('ui-dynamicdialog')[0], this.config.data.gmapCb.scope);
    const overlayElem = document.getElementsByClassName('ui-widget-overlay')[0];
    overlayElem.parentNode.removeChild(overlayElem);
    this.validateMasterOrTransac();
    const latLngs = [];
    if (!this.config.data.coordinates && !this.config.data.coordinates.length) {
      this.utils.getCoords(this.config.data.polygon).forEach(element => {
        latLngs.push({lat: element.lat(), lng: element.lng()});
      });
      this.coordinates = latLngs;
    } else {
      this.coordinates = this.config.data.coordinates;
    }
  }
}
